import NGOProjectsLayout from 'features/ngo/projects'
import React from 'react'

const NGOProjects = () => {
  return (
    <NGOProjectsLayout />
  )
}

export default NGOProjects